import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import api, { eventApi } from "@/lib/api";
import { getCountry } from "@/lib/geo";

const Ctx = createContext(null);

export function EventProvider({ children }) {
  const { eventId } = useParams();
  const eapi = useMemo(() => eventApi(eventId), [eventId]);
  const [event, setEvent] = useState(null);
  const [features, setFeatures] = useState(null);
  const [error, setError] = useState(false);

  const reloadEvent = useCallback(async () => {
    try { const { data } = await api.get(`/events/${eventId}`); setEvent(data); return data; }
    catch { setError(true); return null; }
  }, [eventId]);

  const refreshFeatures = useCallback(async () => {
    try {
      const country = await getCountry();
      const { data } = await eapi.get("/features", country ? { params: { country } } : undefined);
      setFeatures(data); return data;
    }
    catch { return null; }
  }, [eapi]);

  useEffect(() => {
    let active = true;
    (async () => {
      const e = await reloadEvent();
      if (!active) return;
      if (e && e.my_role === "host") await refreshFeatures();
      else setFeatures({ catalog: [], unlocked: e?.unlocked_features || [], price: 5 });
    })();
    return () => { active = false; };
  }, [reloadEvent, refreshFeatures]);

  const value = { eventId, eapi, event, setEvent, reloadEvent, features, refreshFeatures, role: event?.my_role, error };
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useEvent = () => useContext(Ctx);
